import { render } from "./noCookies.vue?vue&type=template&id=2c0b4f11&scoped=true"
import script from "./noCookies.vue?vue&type=script&lang=js"
export * from "./noCookies.vue?vue&type=script&lang=js"

import "./noCookies.vue?vue&type=style&index=0&id=2c0b4f11&lang=css&scoped=true"

import exportComponent from "C:\\Users\\ulrik\\vueProjects\\ezida\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0b4f11"]])

export default __exports__